// extracted by mini-css-extract-plugin
export default {"card":"TopicCard_card__wJeG8"};